define('views/blocks/AddressIconAliasSelectorView',['jquery','underscore','backbone','app','SubView',
        'TagCommander',
        'models/AddressModel',
        'template!blocks/account/address-icon-alias-selector',
       ],
    function ($,_,Backbone,app,SubView,
              TagCommander,
              AddressModel,
              addressIconAliasSelectorTemplate
              ) {

        return Backbone.View.extend(SubView).extend({

            events: {
                'submit .alias-form':'onSubmitAlias',
                'click button.address-icon-alias-selector__button':'onClickItem',
            },

            className:'address-icon-alias-selector__x',

            initialize: function (options) {
                var view = this, focusIn = false;
                _(view).extend(options);
                view.render();
                function focusChange(e){
                    if(focusIn && !view.$el.find(e.target).get(0)){
                        focusIn = false;
                        app.$window.off('click',focusChange);
                        view.hide();
                    }else{
                        focusIn = true;
                    }
                }
                app.$window.on('click',focusChange);
                setTimeout(function(){
                   focusIn = true;
                },10);
                // TagCommander.eventGA(input,"Panier","Utiliser un avantage",advantage.getName());
            },
            render: function () {
                var view = this,
                    types = AddressModel.getIconTypes(),
                    customAliasType = types.shift();
                types.push(customAliasType);
                var offset = view.$el.parent().offset(),
                    winWidth = app.$window.width(),
                    diff = Math.max(0,(offset.left+Math.min(winWidth,346)/2) - winWidth);

                view.$el.html(addressIconAliasSelectorTemplate({
                    types:types,
                    customAlias:customAliasType
                }))
                if(diff>0){
                    view.$el.css({left:-diff});
                    view.$('.tick').css({marginLeft:diff/2});
                }
            },
            onClickItem:function(e){
                var view = this,
                    type = view.$(e.currentTarget).data('type');
                e.preventDefault();
                e.stopPropagation();
                view.saveAddress(type);
            },
            onSubmitAlias:function(e){
                //this.remove();
                var view = this,
                    input = view.$(':text'),
                    val = input.val();
                e.preventDefault();
                e.stopPropagation();
                if(!!val){
                    view.saveAddress(0,val);
                }else{
                    input.focus();
                }
            },
            saveAddress:function(iconType,alias){
                var view = this, address,
                    attr = {},
                    isCart = view.type === 'cart',
                    cart = app.getCart();
                view.$('button,input').attr('disabled',true);
                view.$('.alias-form :submit').addClass('loading');
                if(isCart) {
                    address = cart.getTemporaryAddress();
                    attr.attach_to_cart = 1;
                }else{
                    address = view.address;
                }
                attr.type = iconType;
                attr.alias = !!alias ? alias : AddressModel.getAliasLabel(iconType);
                address.set(attr);
                view.hide();
                function onSave(a,b,c){
                    if(isCart){
                        var place = address.getPlace();
                        if(place) place.set(attr);
                        cart.updateDeliveryOptions(attr);
                    }
                    app.trigger('changeAddressAlias',address);
                }
                if(isCart && address.isNew()){
                    onSave();
                }else{
                    address.once('sync error',onSave);
                    address.save();
                }
            },
            hide:function(){
                var view = this;
                view.remove();
            },
            close: function ()
            {
                this.trigger('close', this);
            }

        });
    });
